import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const AdminAuthorizedApi = createApi({
  reducerPath: "AdminAuthorizedApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_Authorized_API_URL}/api/admin/live/chat/`,
  }),
  tagTypes: ["AdminAuthorized"],
  endpoints: (builder) => ({
    // UserAuthorizedData: builder.mutation({
    //   query: (token) => `authorized?token=${token}`,
    // }),

    AdminAuthorizedData: builder.mutation({
      query: (data) => ({
        url: "authorized",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (results, error) => [
        { type: "AdminAuthorized", results, error, id: "LIST" },
      ],
    }),
    getAuthorizedDataById: builder.query({
      query: (id) => `authorized/${id}`,
      providesTags: (results, error) => [
        { type: "AdminAuthorized", results, error, id: "LIST" },
      ],
    }),
  }),
});

export const {
  useAdminAuthorizedDataMutation,
  useGetAuthorizedDataByIdQuery
} = AdminAuthorizedApi;
